import styled from 'styled-components'

export const LogAccessUsersContainer = styled.div``
